module.exports = __webpack_public_path__ + "static/img/englishBg.46c2fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/englishBg.png
// module id = ysLD
// module chunks = 1